export default __webpack_public_path__ + "static/media/fabula_logo.9e6977da.svg";